import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { NavController, Platform } from '@ionic/angular';
import { CartServiceService } from 'src/app/services/cart-service.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { UiServices } from 'src/app/services/ui-services';
import { MultioComponent } from '../../components/multio/multio.component';
import { LoginService } from 'src/app/services/login.service';
import { NotificationsComponent } from '../../components/notifications/notifications.component';
import { PwaService } from 'src/app/services/pwa.service';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from 'src/app/services/storage.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { MenuService } from 'src/app/services/menu.service';
import { ChangeBranchComponent } from 'src/app/components/change-branch/change-branch.component';
import { BalanceService } from 'src/app/services/balance.service';
import { LangService } from 'src/app/services/lang.service';

@Component({
  selector: 'app-headercomponent',
  templateUrl: './headercomponent.component.html',
  styleUrls: ['./headercomponent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeadercomponentComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('addCart') addCart: ElementRef<HTMLDivElement>;
  @ViewChild('newNotification') newNotification: ElementRef<HTMLDivElement>;
  @ViewChild('colSearchbar', { static: false }) colSearchbar: any;

  private _balanceObs: Subscription = new Subscription();
  public loadingIndicator = false;
  public toogleSearchbar = false;
  public searchIcon: string = './assets/icons/buscador.svg';
  public cartIcon: string = './assets/icons/';
  public multimonedaIcon: string = './assets/icons/moneda.svg';
  public optsMenu: any[] = [];
  public logined: string;
  public totalCart: number = 0;
  public logo: {
    logo: string;
    width?: number;
    height?: number;
  } = {
    height: undefined,
    width: undefined,
    logo: '',
  };
  public domainId = environment.domainId;
  public msgWpp: string = '';
  public headerSuscription = new Subscription();
  public numWpp = '';
  public search = '';
  public placeholder = '';
  public borderRadius = '';
  public emited = false;
  public addSubscription: Subscription = new Subscription();
  public totalObs: Subscription = new Subscription();
  public buttons = [];
  public typeSearchbar: any = '';

  //Variables para el estilo del wpp flotante
  public total = 0;
  public actualRoute = undefined;
  public dinamicHeader = false;
  public headerStyle = undefined;
  public currency: any = undefined;
  public currencyName = 'USD';

  public accCk = false;
  public availableCk = false;

  public addPaddingTop = false;

  constructor(
    private navCtrl: NavController,
    private httpSv: HttpService,
    private renderer: Renderer2,
    private uiSv: UiServices,
    private platform: Platform,
    private balanceSv: BalanceService,
    public cartSv: CartServiceService,
    public paramSv: ParamServicesService,
    public loginSv: LoginService,
    public notificationSv: NotificationsService,
    public pwaSv: PwaService,
    @Inject(PLATFORM_ID) private platformId: any,
    private storageSv: StorageService,
    private cdr: ChangeDetectorRef,
    private menuSv: MenuService,
    public langSv: LangService
  ) {
    this.addSubscription.add(
      this.paramSv.reload.subscribe((x) => {
        this.totalObs.unsubscribe();
        this.ngOnInit();
      })
    );

    this.addSubscription.add(
      this.httpSv.loadingIndicatorObs.subscribe((data: boolean) => {
        this.loadingIndicator = data;
        this.cdr.markForCheck();
      })
    );

    this.notificationSv.count$.subscribe((x) => {
      this.cdr.markForCheck();
    });

    this.cartSv.total$.subscribe((x) => {
      this.cdr.markForCheck();
    });

    if (this.platform.is('pwa')) {
      this.pwaSv.backbutton = true;
    }
  }

  async ngOnInit() {
    if (this.balanceSv.currency) {
      this.currency = this.balanceSv.currency;
      this.setCurrencyChange(this.balanceSv.currency);
    }
    this._balanceObs.add(
      this.balanceSv.currencySource.subscribe((res) => {
        this.currency = res;
        this.setCurrencyChange(this.currency);
      })
    );

    setTimeout(() => {
      this.currency = this.balanceSv?.currency;
      this.setCurrencyChange(this.currency);
    });

    try {
      if (!isPlatformBrowser(this.platformId)) {
        return false;
      }

      if (!this.platform.is('capacitor')) this.availableCk = true;

      this.notificationSv.totalNotifications();

      const ck = this.storageSv.getLocalStorage('accCk');
      this.accCk = JSON.parse(ck);
      this.actualRoute = window.location.pathname;
      this.totalObs.add(
        this.cartSv.totalSrcObs.subscribe((data: any) => {
          const element = this.addCart?.nativeElement;
          this.showAddedToAlert(element, data);
          this.total = data.total;
        })
      );
      this.totalObs.add(
        this.notificationSv.showNotification.subscribe(() => {
          const element = this.newNotification?.nativeElement;
          this.showAddedToAlert(element, { emit: true });
        })
      );
      let headerValue = this.paramSv?.headerParams?.value;
      const savedLogo = this.paramSv.savedLogo;
      savedLogo?.length && this.setLogo();

      if (headerValue) {
        headerValue = headerValue;
        this.setProperties(headerValue);
      }

      // Agrego suscipciones al contenedor de las mismas para luego
      // desuscribirme de ellas.

      if (this.paramSv.styles) {
        this.setStylesFromParams();
      }

      this.headerSuscription = this.paramSv.emitImagesObs.subscribe(
        async (item: any) => {
          if (item?.name === 'logo' && !this.logo.logo) {
            let headerValue = this.paramSv?.headerParams?.value;
            this.setProperties(headerValue);
            this.setLogo();
          } else if (item === 'finish') {
            this.headerSuscription.unsubscribe();
          } else if (item.name === 'styles') {
            this.setStylesFromParams();
          }
          this.cdr.markForCheck();
        }
      );
      this.detectChanges();
    } catch (err) {
      console.error(err);
    }
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  showAddedToAlert(element, data) {
    if (element && data.emit) {
      this.renderer.setStyle(element, 'display', 'block');
      this.renderer.addClass(element, 'addedCart');
      setTimeout(() => {
        this.renderer.removeStyle(element, 'display');
        this.renderer.removeClass(element, 'addedCart');
      }, 3000);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.currency = this.balanceSv?.currency;
      this.setCurrencyChange(this.currency);
    });
  }

  async toogleMenu() {
    this.menuSv.toogleMenu.next(true);
  }

  setStylesFromParams() {
    const cart = this.paramSv.styles.find(
      (item) => item.text === 'Carrito'
    )?.selected;
    this.headerStyle = this.paramSv.styles.find(
      (item) => item.text === 'Header'
    )?.selected;
    this.cartIcon = './assets/icons/' + (cart || 'carrito2.svg');
    this.cdr.detectChanges();
  }

  async showNotifications(ev) {
    await this.uiSv.showPopover(NotificationsComponent, '', 'notification', ev);
    this.notificationSv.notifications = [];
    this.notificationSv.page = 1;
    this.notificationSv.totalPages = 1;
  }

  ngOnDestroy(): void {
    this.addSubscription?.unsubscribe();
    this._balanceObs.unsubscribe();
  }

  async setCurrencyChange(currency) {
    this.currencyName = currency?.symbol || this.balanceSv.currencyBaseName;
    this.cdr.markForCheck();
  }

  setLogo() {
    const logoData = this.paramSv.setLogo('Header');
    this.logo = logoData;
    this.detectChanges();
  }

  async setProperties(headerValue) {
    try {
      if (typeof headerValue === 'string') {
        headerValue = JSON.parse(headerValue);
      }
      const data = headerValue;
      if (data) {
        const {
          optsMenu,
          placeholder,
          typeSearchbar,
          buttonsHeader,
          borderRadius,
        } = await this.paramSv.setProperties(headerValue);
        this.optsMenu = optsMenu;
        this.placeholder = placeholder;
        this.borderRadius = borderRadius || '2px';
        this.typeSearchbar = typeSearchbar;
        this.buttons = buttonsHeader;
        this.cartSv.setCart();
      }
      this.detectChanges();
    } catch (err) {
      console.error(err);
    }
  }

  showSearchbar() {
    if (
      !window.matchMedia('(min-width: 950px)').matches ||
      this.typeSearchbar === 'hidden'
    ) {
      const el = this.colSearchbar.el;
      if (!this.toogleSearchbar) {
        this.renderer.addClass(el, 'col-searchbar-show');
      } else {
        this.renderer.addClass(el, 'hideBar');
        setTimeout(() => {
          this.renderer.removeClass(el, 'col-searchbar-show');
          this.renderer.removeClass(el, 'hideBar');
        }, 500);
      }

      this.toogleSearchbar = !this.toogleSearchbar;
    }
  }

  async openMulticurrency(ev) {
    await this.uiSv.showPopover(MultioComponent, {}, '', ev);
  }

  acceptCookies() {
    this.storageSv.setLocalStorage('accCk', JSON.stringify(true));
    this.accCk = true;
  }

  async openBranch(ev) {
    await this.uiSv.showPopover(ChangeBranchComponent, {}, 'branch-pop', ev);
  }

  goTo(url) {
    this.navCtrl.navigateForward(url);
  }

  changeLanguage(ev) {
    this.langSv.openLanguagePopover(ev);
  }
}
